export type EmploymentTypeTranslator = (key: string) => string;

interface EmploymentTypeNameSource {
  code?: string | null;
  name: string;
}

const DEFAULT_EMPLOYMENT_TYPE_KEYS: Record<string, { name: string; i18nKey: string }> = {
  full_time: {
    name: 'Full-time',
    i18nKey: 'org:activeWorkers.employmentTypes.fullTime',
  },
  part_time: {
    name: 'Part-time',
    i18nKey: 'org:activeWorkers.employmentTypes.partTime',
  },
  contract: {
    name: 'Contract',
    i18nKey: 'org:activeWorkers.employmentTypes.contract',
  },
  intern: {
    name: 'Intern',
    i18nKey: 'org:activeWorkers.employmentTypes.intern',
  },
};

/**
 * Localize only untouched platform defaults. A matching code is not enough:
 * once a customer renames a default row, their exact name remains authoritative.
 */
export function employmentTypeDisplayName(
  employmentType: EmploymentTypeNameSource,
  t: EmploymentTypeTranslator,
): string {
  const defaultType = employmentType.code
    ? DEFAULT_EMPLOYMENT_TYPE_KEYS[employmentType.code]
    : undefined;
  return defaultType && employmentType.name === defaultType.name
    ? t(defaultType.i18nKey)
    : employmentType.name;
}
